export const faqData = [
  {
    id: 1,
    question: '韩漫之家是什么？',
    answer: '韩漫之家是一个专注于韩国漫画的在线观看平台，汇集海量正版韩漫资源，支持下拉式阅读模式，提供高清画质与快速更新，致力于为广大韩漫爱好者打造安心的阅读环境。',
  },
  {
    id: 2,
    question: '韩漫之家上的漫画是正版的吗？',
    answer: '是的，韩漫之家平台上所有漫画均获得正版授权，我们与多家韩国漫画出版社和创作团队建立了长期合作关系，确保每一部作品都是官方授权的正版内容，让读者可以放心阅读。',
  },
  {
    id: 3,
    question: '什么是下拉式韩漫阅读？',
    answer: '下拉式韩漫是一种专为移动端和网页端优化的漫画阅读模式，读者只需向下滑动页面即可连续阅读，无需翻页操作。这种阅读方式更加流畅自然，特别适合竖屏浏览，是韩漫的标志性阅读体验。',
  },
  {
    id: 4,
    question: '韩漫之家的更新频率是怎样的？',
    answer: '我们与韩国漫画版权方保持密切合作，大部分热门作品能够在韩国本土更新后24-48小时内完成汉化上线。每周都有多部作品持续更新，追更爱好者可以关注首页的「最新更新」板块获取第一手信息。',
  },
  {
    id: 5,
    question: '韩漫之家需要付费吗？',
    answer: '韩漫之家提供部分免费章节供读者试读体验。对于付费内容，我们提供多种灵活的阅读方案，包括按章节购买、月度会员以及年度会员等选择，价格公道，让每一位读者都能以最合适的方式享受韩漫。',
  },
  {
    id: 6,
    question: '如何在韩漫之家找到我想看的漫画？',
    answer: '您可以通过多种方式找到心仪的漫画：在首页使用搜索功能按作品名或作者名搜索；通过分类页面按恋爱、奇幻、动作、悬疑、搞笑、剧情等类型浏览；也可以查看首页的精选推荐和排行榜，发现热门好作品。',
  },
];